export function shouldResetUrgencyDismissal(source) {
    return source !== 'pagination';
}

export function shouldTrackUrgencyImpression(urgencyEnabled, urgencyDismissed) {
    return Boolean(urgencyEnabled) && !urgencyDismissed;
}
